import { render, staticRenderFns } from "./NotificationSettings.vue?vue&type=template&id=8c41ead0&scoped=true&"
import script from "./NotificationSettings.vue?vue&type=script&lang=js&"
export * from "./NotificationSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c41ead0",
  null
  
)

export default component.exports